/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';

/**
 * 
 * @export
 * @interface InstructionDto
 */
export interface InstructionDto {
    /**
     * 
     * @type {string}
     * @memberof InstructionDto
     */
    textAreaContent?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof InstructionDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof InstructionDto
     */
    $type?: InstructionDtoTypeEnum;
}


/**
 * @export
 */
export const InstructionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoInstructionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.InstructionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type InstructionDtoTypeEnum = typeof InstructionDtoTypeEnum[keyof typeof InstructionDtoTypeEnum];


/**
 * Check if a given object implements the InstructionDto interface.
 */
export function instanceOfInstructionDto(value?: unknown): value is InstructionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(InstructionDtoTypeEnum)[0];
}

export function InstructionDtoFromJSON(json: any): InstructionDto {
    return InstructionDtoFromJSONTyped(json, false);
}

export function InstructionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstructionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'textAreaContent': !exists(json, 'textAreaContent') ? undefined : json['textAreaContent'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function InstructionDtoToJSON(value?: InstructionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'textAreaContent': value.textAreaContent,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        '$type': value.$type,
    });
}

